import { apiService } from "../../app.service";

export const incidentApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch a incident
    fetchIncident: builder.query({
      query: (id) => ({
        url: `/user/incidents/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "incident", id: result._id }] : [],
    }),

    // Fetch all incidents
    fetchIncidents: builder.query({
      query: () => ({
        url: "/user/incidents",
      }),
      providesTags: ["incidents"],
    }),

    // Create a new incident
    createIncident: builder.mutation({
      query: (data) => ({
        url: "/user/incidents",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["incidents"],
    }),

    // Update an existing incident
    updateIncident: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/incidents/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "incident", id },
        "incidents",
      ],
    }),

    // Delete a incident
    deleteIncident: builder.mutation({
      query: (id) => ({
        url: `/user/incidents/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["incidents"],
    }),
  }),
});

export const {
  useFetchIncidentsQuery,
  useFetchIncidentQuery,
  useCreateIncidentMutation,
  useUpdateIncidentMutation,
  useDeleteIncidentMutation,
} = incidentApi;
